import React from "react"

import { parse } from "node-html-parser"

import { graphql, Script } from "gatsby"

import { getImage } from "gatsby-plugin-image"

import BlogPostTransformer from "../components/parsers/BlogPostTransformer"
import PostSearchieParser from "../helpers/PostSearchieParser"

import Byline from "../components/Byline"
import Cubewise from "../components/layouts/Cubewise"
import BlogPostToC from "../components/BlogPostToC"
import RelatedContent from "../components/RelatedContent"

import moment from "moment"

import { CookieNotice } from "gatsby-cookie-notice"

import Seo from "../components/Seo"

import * as blogPostSectionStyles from "../styles/BlogPost.module.css"

export default function BlogPost(props) {
  const post = props.data.allWpPost.nodes[0]

  // const author =
  //   (post.author && post.author.node && post.author.node.name) || `Cubewiser`
  const date = post.date
  const excerpt = post.excerpt

  const postId = post.slug

  const postCategories =
    (post.categories &&
      post.categories.nodes &&
      post.categories.nodes.map(c => c.name)) ||
    []

  let featuredImage = null
  if (
    post.featuredImage &&
    post.featuredImage.node &&
    post.featuredImage.node.localFile
  )
    featuredImage = getImage(post.featuredImage.node.localFile)

  const { ids: gistIds, content: parsedContent } = PostSearchieParser(
    post.content,
  )

  const content = BlogPostTransformer(parsedContent)

  return (
    <>
      <Cubewise data={props.data} pageContext={props.pageContext}>
        <div className={`row ${blogPostSectionStyles.tableContentsWrapper}`}>
          <div
            className={`col-3 .d-none .d-lg-block .d-xl-block ${blogPostSectionStyles.tableContents}`}
          >
            <BlogPostToC headings={content.headings} />
          </div>
          <div
            className={`col-xs-10 col-sm-10 col-md-10 col-lg-6 col-xl-6 ${blogPostSectionStyles.wrapper}`}
          >
            <Byline
              authorName={post.author.node.name}
              authorAvatar={post.author.node.avatar.url}
            />
            <p className={`${blogPostSectionStyles.date}`}>
              {moment(date).format("MMM D YYYY")}
            </p>
            {/*   <h3 className={`${blogPostSectionStyles.wordsmith}`}>
            <Trans>Written by</Trans>&nbsp;<Trans>{author}</Trans>
          </h3> */}
            <h1 className={`${blogPostSectionStyles.title}`}>
              {post.title &&
                post.title.replace(/&nbsp;/g, " ").replace(/\u00a0/g, " ")}
            </h1>
            {/* {featuredImage && (
            <div className={`${blogPostSectionStyles.featuredImage}`}>
              <GatsbyImage image={featuredImage} alt={post.title} />
            </div>
          )} */}
            {/* {!postCategories.includes(`EducationSource`) && ( */}
            <p
              className={`${blogPostSectionStyles.extract}`}
              dangerouslySetInnerHTML={{ __html: excerpt }}
            />
            {/* )} */}
            <div
              dangerouslySetInnerHTML={{ __html: content.body }}
              className={`${blogPostSectionStyles.body}`}
            />

            {/* <div className={`${blogPostSectionStyles.tagList}`}>
            {post.tags &&
              post.tags.nodes &&
              post.tags.nodes.map((tag, indx) => (
                <span key={indx}>#{tag.name}&nbsp;</span>
              ))}
          </div> */}
          </div>
        </div>
        <div className={`row ${blogPostSectionStyles.relatedContentWrapper}`}>
          <div className={`col-12 ${blogPostSectionStyles.relatedContent}`}>
            <RelatedContent
              postId={postId}
              postCategories={postCategories}
              pageContext={props.pageContext}
            />
          </div>
        </div>
        {process.env.GATSBY_SEARCH_BOT_ON === "true" && (
          <expertise-ai client="cab0dbfd-d18a-4e2a-8daf-7f682340ad62"></expertise-ai>
        )}
        <CookieNotice
          personalizeButtonEnable={false}
          personalizeValidationText={"Accept"}
          declineButton={false}
          wrapperClasses={`d-flex justify-content-between`}
        >
          <h4>This websites uses cookies.</h4>
          <p>
            We use cookies on our website to give you the most relevant
            experience by remembering your preferences and repeat visits. By
            clicking “Accept”, you consent to the use of ALL the cookies.
          </p>
        </CookieNotice>
      </Cubewise>

      {process.env.GATSBY_MATOMO_ID && (
        <Script
          dangerouslySetInnerHTML={{
            __html: `;var _paq=window._paq=window._paq||[];_paq.push(["trackPageView"]),_paq.push(["enableLinkTracking"]),_paq.push(["enableHeartBeatTimer"]),function(){_paq.push(["setTrackerUrl","https://apliqo.matomo.cloud/matomo.php"]),_paq.push(["setSiteId","10"]);var a=document,e=a.createElement("script"),t=a.getElementsByTagName("script")[0];e.async=!0,e.src="https://cdn.matomo.cloud/apliqo.matomo.cloud/matomo.js",t.parentNode.insertBefore(e,t)}();`,
          }}
        />
      )}

      {process.env.GATSBY_SEARCH_BOT_ON === "true" && (
        <Script
          src="https://d31ptbphd2zjsx.cloudfront.net/genweb/ai-genweb.js"
          defer
        />
      )}
    </>
  )
}

export const Head = ({ location, params, data, pageContext }) => {
  const page = data.allWpPost.nodes[0]

  const excerpt = page.excerpt && parse(page.excerpt).text.trim()

  const description = excerpt || page.title

  let stopIndx = 0
  let stopPunc = `.`
  if (description.length >= 104) {
    stopIndx = 102
    stopPunc = `...`
  } else {
    stopIndx =
      description.indexOf(`.`) === -1
        ? description.length
        : description.lastIndexOf(`.`)
  }

  return (
    <Seo
      title={page.title}
      description={
        (page.seo && page.seo.metaDesc) ||
        description.substring(0, stopIndx) + stopPunc
      }
      thumbnail={page.acfWorkarounds && page.acfWorkarounds.acfFeaturedImage}
    />
  )
}

export const query = graphql`
  query (
    $slug: String!
    $language: String!
    $headerMenuLocation: WpMenuLocationEnum!
    $footerMenuLocation: WpMenuLocationEnum!
  ) {
    allWpPost(filter: { slug: { eq: $slug } }) {
      nodes {
        id
        date
        title
        slug
        excerpt
        content
        categories {
          nodes {
            name
          }
        }
        tags {
          nodes {
            name
          }
        }
        author {
          node {
            id
            name
            avatar {
              url
            }
          }
        }
      }
    }

    languages: allWp {
      edges {
        node {
          languages {
            code
            slug
            name
            locale
          }
        }
      }
    }

    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }

    menu: wpMenu(locations: { eq: $headerMenuLocation }) {
      id
      name
      menuItems {
        nodes {
          id
          label
          path
          parentId
          connectedNode {
            node {
              id
              ... on WpPage {
                id
                excerpt
                subMenuEntries {
                  subMenuPage1 {
                    subMenuPageName
                    subMenuPageLink {
                      ... on WpPage {
                        uri
                      }
                    }
                  }
                  subMenuPage2 {
                    subMenuPageName
                    subMenuPageLink {
                      ... on WpPage {
                        uri
                      }
                    }
                  }
                  subMenuPage3 {
                    subMenuPageName
                    subMenuPageLink {
                      ... on WpPage {
                        uri
                      }
                    }
                  }
                  subMenuPage4 {
                    subMenuPageName
                    subMenuPageLink {
                      ... on WpPage {
                        uri
                      }
                    }
                  }
                  subMenuPage5 {
                    subMenuPageName
                    subMenuPageLink {
                      ... on WpPage {
                        uri
                      }
                    }
                  }
                  subMenuPage6 {
                    subMenuPageName
                    subMenuPageLink {
                      ... on WpPage {
                        uri
                      }
                    }
                  }
                  subMenuPage7 {
                    subMenuPageName
                    subMenuPageLink {
                      ... on WpPage {
                        uri
                      }
                    }
                  }
                  subMenuPage8 {
                    subMenuPageName
                    subMenuPageLink {
                      ... on WpPage {
                        uri
                      }
                    }
                  }
                  subMenuPage9 {
                    subMenuPageName
                    subMenuPageLink {
                      ... on WpPage {
                        uri
                      }
                    }
                  }
                }
                subMenuExternalEntries {
                  subMenuExternalLink1 {
                    subMenuLinkName
                    subMenuLinkUrl
                  }
                  subMenuExternalLink2 {
                    subMenuLinkName
                    subMenuLinkUrl
                  }
                  subMenuExternalLink3 {
                    subMenuLinkName
                    subMenuLinkUrl
                  }
                  subMenuExternalLink4 {
                    subMenuLinkName
                    subMenuLinkUrl
                  }
                  subMenuExternalLink5 {
                    subMenuLinkName
                    subMenuLinkUrl
                  }
                  subMenuExternalLink6 {
                    subMenuLinkName
                    subMenuLinkUrl
                  }
                }
              }
            }
          }
        }
      }
    }

    footerMenu: wpMenu(locations: { eq: $footerMenuLocation }) {
      id
      name
      menuItems {
        nodes {
          id
          label
          path
          parentId
          connectedNode {
            node {
              id
              ... on WpPage {
                id
                excerpt
              }
            }
          }
        }
      }
    }
  }
`
